import SectionHeading from "~/components/SectionHeading";
import InvoiceIcon from "~/components/icons/InvoiceIcon";
import { formatCurrency } from "~/lib/CurrencyHelpers";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import useBusinessNavigate from "~/lib/useBusinessNavigate";
import InvoiceStatusBadge from "~/components/invoices/InvoiceStatusBadge";

const InvoicesList = ({ invoices, className }) => {
    const navigate = useBusinessNavigate();

    if (!invoices?.length) {
        return null;
    }

    return (
        <div className={className}>
            <SectionHeading icon={<InvoiceIcon />} name="Invoices" />
            <div className="mt-2 panel pl-4 divide-y">
                {invoices.map((invoice) => (
                    <div
                        className="cursor-pointer py-3 mr-4 flex items-center justify-between"
                        onClick={() => navigate(`/invoices/${invoice.id}`)}
                        key={invoice.id}
                    >
                        <div className="flex-1">
                            <div className="flex items-center gap-2">
                                <span className="font-medium">Invoice #{invoice.invoice_number}</span>
                                <InvoiceStatusBadge status={invoice.status} />
                            </div>
                            <div className="text-gray-500 mt-1">{formatCurrency(invoice.total)}</div>
                        </div>
                        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InvoicesList;

